import { BaseService } from '../../infra/base.service'
import type { CountriesRepository } from './countries.repository'
import type { CountryEntity } from './country.entity'

export class CountriesService extends BaseService<CountryEntity> {
    constructor(private rep: CountriesRepository) {
        super(rep)
    }
}
